import { Dictionary } from '@reduxjs/toolkit';
import { GiftJson } from './GiftJson';

export const matchActiveVariant = (
    variants: GiftJson.Variant<any>[],
    activeInputs: Dictionary<GiftJson.Input<any>>
) => {
    return variants.find(v => v.match && isMatch(v, activeInputs))
        || variants.find(v => !v.match)
        || variants[0];
};

const isMatch = (
    variant: GiftJson.Variant<any>,
    inputs: Dictionary<GiftJson.Input<any>>
) => {

    if (!variant.match) {
        throw new Error('Variant has no `match` property.');
    }

    for (const [inputId, requiredValues] of Object.entries(variant.match)) {

        const input = inputs[inputId];
        if (!input) {
            return false;
        }

        for (const [propertyName, requiredValue] of Object.entries(requiredValues!)) {
            if (input.value[propertyName] !== requiredValue) {
                return false;
            }
        }
    }

    return true;
};